import React from 'react';
import {ExclamationCircleFilled} from '@ant-design/icons';
import {Modal} from 'antd';

const {confirm} = Modal;

const confirmAction = (
    title,
    description = '',
    handleOk,
    handleOkParam,
    handleCancel,
    btnOkText = 'Yes',
    btnCancelText = 'No'
) => {

    confirm({
        title: title,
        content: description,
        okText: btnOkText,
        okType: 'primary',
        cancelText: btnCancelText,
        cancelButtonProps: {
            type: 'default'
        },
        width: 433 + 'px',
        icon: <ExclamationCircleFilled />,
        maskClosable: true,

        onOk() {
            handleOkParam !== undefined ?
            handleOk(handleOkParam) : handleOk();
        },

        onCancel() {
            if (handleCancel !== undefined) {
                handleCancel();
            }
        },
    })
};

export default confirmAction;
